import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { mediaTypesMap } from '../models';
export function ExternalMediaList({
  medias,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Wrapper, props, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.external_media"
  })), medias.map(({
    id,
    type,
    title,
    url
  }) => {
    const mediaType = mediaTypesMap.find(({
      key
    }) => key === type);
    if (!mediaType) return /*#__PURE__*/React.createElement(React.Fragment, {
      key: id
    });
    const {
      labelKey,
      Icon
    } = mediaType;
    return /*#__PURE__*/React.createElement(_Tooltip, {
      key: id,
      placement: "bottom",
      title: title || /*#__PURE__*/React.createElement(Trans, {
        i18nKey: labelKey
      })
    }, /*#__PURE__*/React.createElement(_IconButton, {
      component: "a",
      href: url,
      rel: "noreferrer",
      size: "small",
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Icon, null)));
  }));
}
const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  height: 36px;
  justify-content: flex-end;
  padding: 0 16px;
`;